import { $themeConfig } from '@themeConfig'



export const appConfig = defineStore('app-config',() => {
  // propiedades del layout
  const layout = ref({
    skin: localStorage.getItem("vuexy-skin") || $themeConfig.layout.skin,
    routerTransition:
      localStorage.getItem("transition") ||
      $themeConfig.layout.routerTransition,
    type: localStorage.getItem("layout_type") || $themeConfig.layout.type,

    contentWidth: $themeConfig.layout.contentWidth,

    menu: {
      hidden: $themeConfig.layout.menu.hidden,
    },

    navbar: {
      type:
        localStorage.getItem("navbar_type") || $themeConfig.layout.navbar.type,
      backgroundColor:
        localStorage.getItem("navbar_color") ||
        $themeConfig.layout.navbar.backgroundColor,
    },

    footer: {
      type:
        localStorage.getItem("footer_type") || $themeConfig.layout.footer.type,
    },
  });

   const UPDATE_SKIN = (skin) => {
      layout.value.skin = skin

      // Update value in localStorage
      localStorage.setItem('vuexy-skin', skin)

      // Update DOM for dark-layout
      if (skin === 'dark') document.body.classList.add('dark-layout')
      else if (document.body.className.match('dark-layout')) document.body.classList.remove('dark-layout')
    };

    
    const UPDATE_ROUTER_TRANSITION = (val) =>  {
      layout.value.routerTransition = val
      localStorage.setItem('transition', val)
    };

    const UPDATE_LAYOUT_TYPE = (val) => {
      layout.value.type = val
      localStorage.setItem('layout_type', val)
    };
    
    const UPDATE_CONTENT_WIDTH = (val) => {
      layout.value.contentWidth = val
    };
    
    const UPDATE_NAV_MENU_HIDDEN = val => {
      layout.value.menu.hidden = val
    };
    
    const UPDATE_NAVBAR_CONFIG = (obj) =>  {
      Object.assign(layout.value.navbar, obj)
      const k = Object.keys(obj)[0]
      if (k == 'backgroundColor'){
        localStorage.setItem('navbar_color',obj.backgroundColor);
      }
      
      if(k == 'type'){
        localStorage.setItem('navbar_type',obj.type)
      }

    };

    const UPDATE_FOOTER_CONFIG = (obj) => {
      Object.assign(layout.value.footer, obj)

      if (obj.type) {
        localStorage.setItem('footer_type', obj.type)
      }
    };


    return {
      layout,
      // methods
      UPDATE_SKIN,
      UPDATE_ROUTER_TRANSITION,
      UPDATE_LAYOUT_TYPE,
      UPDATE_CONTENT_WIDTH,
      UPDATE_NAV_MENU_HIDDEN,
      UPDATE_NAVBAR_CONFIG,
      UPDATE_FOOTER_CONFIG,
    };
}); 
export default appConfig;